import './footer.css'
import { Link as ScrollLink } from 'react-scroll';
import arrowUp from './arrowTop.gif';
import { ReactComponent as IconEmail } from './icons/email.svg';
import { ReactComponent as IconGithub } from './icons/github.svg';
import { ReactComponent as IconLinkedin } from './icons/linkedin.svg';
import { ReactComponent as IconTel } from './icons/tel.svg';
import { useState } from 'react';

import {
    Container, Row, Col, Button, Form, FormGroup, Label, Input
} from 'reactstrap';

const Footer = () => {
    const [formStatus, setFormStatus] = useState('');
    const handleSubmit = async (e) => {
        e.preventDefault(); 
        
        // Message d'attente
        setFormStatus('Envoi en cours...'); 

        // 1. Récupérer les données du formulaire
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        const MAKE_WEBHOOK_URL = ' https://hook.eu1.make.com/khtq29zvj29pt0kssfcc338vlemmg3e3'; 
        
        try {
            const response = await fetch(MAKE_WEBHOOK_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data) 
            });

            if (response.ok) {
                setFormStatus('Message envoyé avec succès !');
                e.target.reset();
            } else {
                setFormStatus('Erreur lors de l\'envoi. Veuillez vérifier la connexion Make.');
            }
        } catch (error) {
            setFormStatus('Erreur réseau. Veuillez réessayer.');
            console.error('Erreur lors de l\'appel Fetch:', error);
        }
    };
    return (
        <Container className='footer-container pt-5' id='about'>
            <Row className='form-row mb-2 contact-form-col'>
                <h3 className='form-title'>Contactez-moi</h3>
                    <Form onSubmit={handleSubmit}>
                        
                        <Row>
                            <Col md={6}>
                                <FormGroup> 
                                    <Label for="name">Nom</Label>
                                    <Input id="name" name="name" type="text" placeholder="Votre Nom Complet" required />
                                </FormGroup>
                            </Col>
    
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="email">Email</Label>
                                    <Input id="email" name="email" type="email" placeholder="votre.email@exemple.com" required />
                                </FormGroup>
                            </Col>
                        </Row>
                        <FormGroup>
                            <Label for="message">Message</Label>
                            <Input id="message" name="message" type="textarea" rows="4" placeholder="Votre message..." required />
                        </FormGroup>
                        
                        <Button className='submit-button' type="submit">Envoyer</Button>
                    </Form>
            </Row>
            <Row className='form-row mb-2'>
                <Col xxs={8}  className='col-copyright'>
                    <p>
                        copyright © 2024 Ebou Christelle.
                    </p>
                    <div className='contact'>
                        <a href='https://www.linkedin.com/in/christyb-a48bb71a4/'><IconLinkedin width={25} height={40}/></a>
                        <a href='https://github.com/christy-B?tab=repositories'><IconGithub width={25} height={40}/></a>
                        <a href='mailto:bienechristy94@gmail.com'><IconEmail width={25} height={40}/></a>
                        <a href='tel:+33662257759'><IconTel width={25} height={40}/></a>
                    </div>
                </Col>

                <Col xxs={4}  className='col-gift'>
                    <ScrollLink
                      className="gift-link"
                      to="header"
                      smooth={true}
                      duration={500}
                      offset={-70}
                    >
                    <img src={arrowUp} alt="Gif" width="100px" />
                    </ScrollLink>
                </Col>
            </Row>
        </Container>
    );
}

export default Footer;